import React from 'react';
import useRouteHandle from '../useRouteHandle';
import PageLayout from './PageLayout';
import DesktopAppFeatures from '../../desktop/DesktopAppFeatures';
import { isElectron } from '../../utils/desktopClient';

const InternalApp = () => {
  const { routeName, pageLayout = {} } = useRouteHandle();

  return (
    <>
      {isElectron && <DesktopAppFeatures />}
      <PageLayout.Root elements={pageLayout} routeName={routeName} />
    </>
  );
};

export default InternalApp;
